import { render, staticRenderFns } from "./GuppyChatUsersList.vue?vue&type=template&id=70d876e8&"
import script from "./GuppyChatUsersList.vue?vue&type=script&lang=js&"
export * from "./GuppyChatUsersList.vue?vue&type=script&lang=js&"
import style0 from "./GuppyChatUsersList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports